import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import moment from "moment";
import { Circles } from "react-loader-spinner";
import { Document, Page, pdfjs } from "react-pdf";
import "./Report.css";
import publicAxios from "../../utils/axios/publicAxios";

// ✅ Properly set up PDF worker
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const Report = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const response = await publicAxios.get(`/public/report/${id}`);
        setReport(response.data.report);
      } catch (error) {
        console.error("Error fetching report", error);
      } finally {
        setLoading(false);
      }
    };
    fetchReport();
  }, [id]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  // ✅ Loading state
  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', columnGap: '10px', alignItems: 'center', justifyContent: 'center', height: '300px', color: 'gray' }}>
        <Circles height="50" width="50" color="#008751" ariaLabel="loading" />
        <h2>Loading Report...</h2>
      </div>
    );
  }

  // ✅ Not found
  if (!report) {
    return (<div style={{ display: 'flex', flexDirection: 'column', columnGap: '10px', alignItems: 'center', justifyContent: 'center', height: '300px', color: 'gray' }}><p>No Report Found</p></div>);
  }

  return (
    <div className="report">
      {/* Header */}
      <div className="report-header">
        <h1>{report.title}</h1>
        <p className="report-meta">
          Posted By: {report.createdBy?.firstname} {report.createdBy?.lastname}{" "}
          | On: {moment(report.createdAt).format("MMMM DD, YYYY")}
          {report.updatedAt &&
            ` | Last Updated: ${moment(report.updatedAt).format("MMMM DD, YYYY")}`}
        </p>
      </div>

      {/* PDF Section */}
      {report.pdfUrl && (
        <div className="report-pdf-wrapper">
          <Document
            file={report.pdfUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<div>Loading PDF...</div>}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <div key={`page_${index + 1}`} className="pdf-page">
                <Page
                  pageNumber={index + 1}
                  renderAnnotationLayer
                  renderTextLayer
                  width={Math.min(window.innerWidth - 10, 800)}
                />
              </div>
            ))}
          </Document>
        </div>
      )}

      {/* HTML Content */}
      <div
        className="report-content"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(report.content),
        }}
      />

      {/* Actions */}
      <div className="report-actions">
        <button onClick={() => navigate("/reports")}>Back to Reports</button>
      </div>
    </div>
  );
};

export default Report;